<template>
    <FGridWindow  ref="gridWindow" url="/mast/factorymng/fctrInventory/inventoryfactorycompanylist"  title="库存地查询"
                  :config="windowConfig" 
                  :show=shows 
                  :windowToBody=appendBody
                  @onClose="onClose"
                  @onSelected="onSelected"
                  @onCellDblClick="onCellDblClick">        
    </FGridWindow>
</template>

<script>
import FGridWindow from 'components/window/SearchWindow.vue';
export default {
    components:{
        FGridWindow
    },
    props:{
      show:{
          Type:Boolean,
          default(){
              return true;
          }
      },
      windowToBody:{
          Type:Boolean,
          default(){
              return false;
          }
      }
    },
    watch:{
      show: {
            handler(newVal, oldVal) {
                console.info('value changed 2', newVal)
                this.shows=newVal;
            },
            deep: true
      },
      windowToBody(newVal,oldVal){
          this.toBody=newVal;
      }
    },
    data(){
        return {
            shows:this.show,
            appendBody:this.windowToBody,
            windowConfig:{
                formConfig: {
                    titleWidth: 100,
                    titleAlign: 'right',          
                    
                    items: [
                        { field: 'inventoryDesc', title: '库存名:', span: 8, size:"mini",itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
                        { field: 'inventoryCode', title: '库存编码:', span: 8,size:"mini", itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
                        { span: 8, align: 'right', collapseNode: true,size:"mini",itemRender: { name: '$buttons', children: [{ props: { type: 'submit',content: '查询', status: 'primary' } }, { props: { type: 'reset',content: '重置' } }] }  },
                        { field: 'companyName', title: '公司名:', folding: true,span: 8, size:"mini",itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
                        { field: 'companyCode', title: '公司编码:',folding: true, span: 8,size:"mini", itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } }
                    ],
                    data: {
                        inventoryDesc: '',
                        inventoryCode: '',
                        companyName:'',
                        companyCode:''
                    }
                },
                // radioConfig:{labelField: 'companyName', highlight: true},
                // radio-config="{labelField: 'name', trigger: 'row'}
                tableConfig:{
                   columns:[
                            // { type: 'checkbox', width: 60, fixed: 'left' },
                            // { type: 'seq', width: 80,  title: '序号',fixed: 'left' },
                            { type: 'radio', width: 60, title: '选项',fixed: 'left' },					
                            { type: 'seq',  field: 'inventoryId', title: '库存点ID'},
                            { field: 'inventoryCode', title: '库存编码'},
                            { field: 'inventoryDesc', title: '库存名'},
                            { field: 'factoryDesc', title: '归属工厂'},
                            { field: 'factoryCode', title: '工厂编码'},                           
                            { field: 'companyName', title: '归属公司'},
                            { field: 'companyCode', title: '公司编码'},
                    ]
               },
               toolbar:[{
                    class:"toolbar-item edit_btn",
                    name:"选取",
                    click:"onSelected"
                }]
            }
        }
    },
    methods:{
        onClose(value){
            this.shows=value;
             this.$emit("onClose",this.shows);    
        },
        onSelected(gridWindow){
            let vm=this, gridWindowData = gridWindow.getRadioRecord();
            vm.$emit("onSelectedInventory",gridWindowData);
        },
        onCellDblClick(row){
            let vm=this;
            vm.$emit("onSelectedInventory",row);
        }
    }
    
}
</script>